import { Slot } from '@radix-ui/react-slot';
import { useOutletContext } from './OutletContext';

interface OutletProps {
  id?: string;
  className?: string;
  asChild?: boolean;
}

export function Outlet({ id, className, asChild }: OutletProps) {
  const { registerOutlet } = useOutletContext();
  const ref = registerOutlet(id);

  const Component = asChild ? Slot : 'div';

  return <Component ref={ref} className={className} />;
}
